import { createMemo, createRoot } from "solid-js"
import { getDeviceUserPreference } from "./deviceUserPreferencesSignal"

export const getDeviceUserPreferenceHiDPI = createRoot(() => {
  const getter = createMemo(() => {
    return getDeviceUserPreference().HiDPI
  })
  return getter
})